import CheckoutDeliveryPricesInfoBlock from "pages/checkout/tabs/checkout-info/CheckoutDeliveryPricesInfoBlock";
import React from "react";
import CheckoutSidebarProducts from "../sidebar-products";
import { useStandardProductType } from "app/hooks/shared/standard-product/useStandardProductType";
import { useCartContext } from "app/providers/CartProvider";

export const CheckoutMobileSidebarInfos = () => {
  const { getCart } = useCartContext();
  const cart = getCart();
  const productAnalysis = useStandardProductType(cart);

  // Check if there are any products with productType code "akoestischepanelen" or "accessoireakoestisch
  const showDeliveryPricesBlock =
    productAnalysis.someAkoestischepanelen ||
    productAnalysis.someAccessoireAkoestischPaneel;
  return (
    <div className="gg-flex gg-w-full gg-flex-col gg-gap-y-5">
      <CheckoutSidebarProducts />

      {showDeliveryPricesBlock && <CheckoutDeliveryPricesInfoBlock />}
    </div>
  );
};
